import { toLocalIsoDate } from "@/utils/date/toLocalIsoDate";

export default () => toLocalIsoDate();
